import { Helmet } from 'react-helmet-async';
import { MainContent, MainContentWrapper } from '@ydistri/ds';
import React, { useEffect } from 'react';
import { useTemplateOrCalculation } from '../../../../../hooks/useTemplateOrCalculation';
import { useGetCalculationQuery } from '../../../apiCalculationDetail';
import CalculationRedistributionImportContent from './components/CalculationRedistributionImportContent';
import { setSubpage } from '../../../../../routes/routerSlice';
import { CalculationDetailSubpages } from '../../../../Calculations/calculationsLib';
import { useAppDispatch } from '../../../../../store';

const CalculationRedistributionImport: React.FC = () => {
  const dispatch = useAppDispatch();
  const calculationData = useTemplateOrCalculation();
  const { data: calculation, isFetching } = useGetCalculationQuery(calculationData.id);

  useEffect(() => {
    dispatch(setSubpage(CalculationDetailSubpages.REDISTRIBUTION));
  }, [dispatch]);

  if (!isFetching && calculation) {
    return (
      <>
        <Helmet title={`Calculation ${calculation.id} - Redistribution Import`} />
        <MainContentWrapper>
          <MainContent>
            <CalculationRedistributionImportContent />
          </MainContent>
        </MainContentWrapper>
      </>
    );
  }
};

export default CalculationRedistributionImport;
